(function () {

    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.stickyheaderblock = window.oneadvanced.stickyheaderblock || {};
    window.oneadvanced.stickyheaderblock.init = function () {
        //console.log("initialising stickyheaderblock...");
        var stickyHeaderBlock = document.querySelectorAll('[data-sh-block-id]');

        if (stickyHeaderBlock.length) {
            var reactiveMenu = document.getElementById("reactive-menu");
            var burger = document.getElementById("hamburger-6");

            for (var sh = 0; sh < stickyHeaderBlock.length; sh++) {
                $(function () {
                    var anchors = document.querySelectorAll("[data-magellan-target]");
                    var links = [];
                    for (var i = 0; i < anchors.length; i++) {
                        links[i] = anchors[i].id;
                        var newListItem = document.createElement("li");
                        var newAnchorLink = document.createElement("a");
                        newAnchorLink.href = "#" + links[i];
                        var content = document.querySelector("#" + links[i]).dataset.anchorName;
                        var newContent = document.createTextNode(content);
                        newAnchorLink.appendChild(newContent);
                        newListItem.appendChild(newAnchorLink);
                        var parent = document.querySelectorAll("[data-magellan]")[0];
                        parent.appendChild(newListItem);
                        Foundation.reInit($('[data-magellan]'));
                    }
                    $("#reactive-menu ul.menu a").on('click', function () {
                        if (Foundation.MediaQuery.current == "small" || Foundation.MediaQuery.current == "medium") {
                            $(reactiveMenu).foundation('toggle');
                            $(burger).foundation('toggle');
                        }
                    });
                });
            }
        }
    };
    window.oneadvanced.stickyheaderblock.hasLoaded = true;
})();